<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">{{ $t('marketCustomers.marketCustomersLabel') }}</span>
        <h3 class="page-title">{{ $t('marketCustomers.marketCustomerEdit') }}</h3>
      </d-col>
      <d-col col sm="6" class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/klienci-z-targow')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          {{ $t('ui.backToList') }}
        </d-button>

        <d-button
          theme="primary"
          @click.prevent="checkBeforeCreatingCustomer"
          class="mr-1">
          <i class="material-icons">add</i>
          {{ $t('marketCustomers.createCustomerFromMarketCustomer') }}
        </d-button>

        <d-button
          theme="success"
          @click.prevent="validateForm"
          class="mr-1">
          <i class="material-icons">add</i>
          {{ $t('marketCustomers.saveMarketCustomer') }}
        </d-button>
      </d-col>
    </d-row>

    <!-- Form -->
    <d-form>
      <validation-observer ref="market-customer-new-form" tag="form">
        <d-card class="mb-5">
          <!-- Dane ogólne -->
          <d-tabs
            v-show="allDataLoaded && !loadError"
            card>
            <!-- Dane ogólne -->
            <d-tab
              :title="$t('ui.generalInfo')"
              active>
              <h4 class="mb-3 pb-3 border-bottom">
                {{ $t('ui.generalInfo') }}
              </h4>

              <div class="form-group">
                <label for="name" class="d-block">
                  {{ $t('ui.name') }}:
                </label>

                <validation-provider
                  rules="required"
                  name="nameField"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    v-model="name" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>

              <hr class="mt-4 mb-4">

              <d-row>
                <d-col cols="6">
                  <div class="form-group">
                    <label>
                      {{ $t('ui.language') }}:
                    </label>

                    <d-form-select
                      v-model="language_id"
                      :options="languagesOptions" />
                  </div>
                </d-col>

                <d-col cols="6">
                  <div class="form-group">
                    <label for="name">
                      {{ $t('settings.currency.currency') }}:
                    </label>

                    <d-form-select
                      v-model="currency_id"
                      :options="currenciesOptions" />
                  </div>
                </d-col>
              </d-row>

              <d-row>
                <d-col cols="3">
                  <div class="form-group">
                    <label class="d-block">
                      {{ $t('marketCustomers.postCode') }}:
                    </label>

                    <d-input
                      v-model="invoice_postcode" />
                  </div>
                </d-col>

                <d-col cols="5">
                  <div class="form-group">
                    <label class="d-block">
                      {{ $t('marketCustomers.city') }}:
                    </label>

                    <d-input
                      v-model="invoice_city" />
                  </div>
                </d-col>

                <d-col cols="4">
                  <div class="form-group">
                    <label for="name" class="d-block">
                      {{ $t('marketCustomers.country') }}:
                    </label>

                    <d-input
                      v-model="country" />
                  </div>
                </d-col>
              </d-row>

              <d-row>
                <d-col cols="8">
                  <div class="form-group">
                    <label for="name" class="d-block">
                      {{ $t('marketCustomers.address') }}:
                    </label>

                    <d-input
                      v-model="invoice_street" />
                  </div>
                </d-col>

                <d-col cols="2">
                  <div class="form-group">
                    <label for="building" class="d-block">
                      {{ $t('marketCustomers.building') }}:
                    </label>

                    <d-input
                      v-model="invoice_building" />
                  </div>
                </d-col>

                <d-col cols="2">
                  <div class="form-group">
                    <label for="building" class="d-block">
                      {{ $t('marketCustomers.locale') }}:
                    </label>

                    <d-input
                      v-model="invoice_locale" />
                  </div>
                </d-col>
              </d-row>

              <d-row>
                <d-col cols="2">
                  <div class="form-group">
                    <label for="building" class="d-block">
                      {{ $t('marketCustomers.invoiceCountryPrefix') }}:
                    </label>

                    <d-input
                      v-model="invoice_country_prefix" />
                  </div>
                </d-col>

                <d-col cols="10">
                  <div class="form-group">
                    <label for="building" class="d-block">
                      {{ $t('marketCustomers.invoiceTaxNumber') }}:
                    </label>

                    <d-input
                      v-model="invoice_tax_number" />
                  </div>
                </d-col>
              </d-row>

              <hr class="mt-4 mb-4">

              <d-row>
                <d-col cols="3">
                  <div class="form-group">
                    <label for="name" class="d-block">
                      {{ $t('marketCustomers.contactName') }}:
                    </label>

                    <d-input
                      v-model="contact_name" />
                  </div>
                </d-col>

                <d-col cols="3">
                  <div class="form-group">
                    <label for="name" class="d-block">
                      {{ $t('marketCustomers.contactSurname') }}:
                    </label>

                    <d-input
                      v-model="contact_surname" />
                  </div>
                </d-col>

                <d-col cols="3">
                  <div class="form-group">
                    <label for="name" class="d-block">
                      {{ $t('marketCustomers.phone') }}:
                    </label>

                    <d-input
                      v-model="phone" />
                  </div>
                </d-col>

                <d-col cols="3">
                  <div class="form-group">
                    <label for="name" class="d-block">
                      {{ $t('marketCustomers.email') }}:
                    </label>

                    <validation-provider
                      rules="email"
                      name="contact_email"
                      v-slot="{ errors }">
                        <d-input
                          :state="errors.length ? 'invalid' : null"
                          v-model="email" />
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                    </validation-provider>
                  </div>
                </d-col>
              </d-row>

              <hr class="mt-4 mb-4">

              <d-row>
                <d-col cols="12">
                  <div class="form-group">
                    <label for="name" class="d-block">
                      {{ $t('marketCustomers.websiteUrl') }}:
                    </label>

                    <d-input
                      v-model="website_url" />
                  </div>
                </d-col>
              </d-row>

              <d-row>
                <d-col cols="12">
                  <div class="form-group">
                    <label for="name" class="d-block">
                      {{ $t('marketCustomers.shopUrl') }}:
                    </label>

                    <d-input
                      v-model="shop_url" />
                  </div>
                </d-col>
              </d-row>

              <hr class="mt-4 mb-4">

              <d-row>
                <d-col cols="6">
                  <div class="form-group">
                    <label for="tag">
                      {{ $t('marketCustomers.tag') }}:
                    </label>

                    <div class="d-flex">
                      <select-tag ref="select-tag" />
                    </div>
                  </div>
                </d-col>
                <d-col cols="6">
                  <div class="form-group">
                    <label for="manager">
                      {{ $t('marketCustomers.accountManager') }}:
                    </label>

                    <div class="d-flex">
                      <validation-provider
                        rules="required"
                        name="name"
                        v-slot="{ errors }"
                        tag="div"
                        class="w-100">
                        <div :class="{ 'form-control': true, 'is-select': true, 'is-invalid': errors.length }">
                          <v-select
                            :options="workers"
                            v-model="account_manager_id"
                            :reduce="worker => worker.id"
                            :filterBy="filterByForWorkers"
                            :placeholder="$t('users.selectWorker')"
                            label="name"
                            :clearable="false">
                            <template slot="no-options">
                              {{ $t('users.noUsersMatchingPhrase') }}&hellip;
                            </template>
                            <template slot="option" slot-scope="option">
                              <div class="d-center">
                                {{ option.name }}
                              </div>
                            </template>
                            <template slot="selected-option" slot-scope="option">
                              <div class="selected d-center">
                                {{ option.name }}
                              </div>
                            </template>
                          </v-select>

                          <div class="invalid-feedback">
                            {{ errors[0] }}
                          </div>
                        </div>
                      </validation-provider>
                    </div>
                  </div>
                </d-col>
              </d-row>
            </d-tab>

            <d-tab :title="$t('marketCustomers.contacts')">
              <contacts
                :contacts="contacts"
                :marketCustomerID="parseInt(this.$route.params.id, 10)" />
            </d-tab>
          </d-tabs>

          <div v-if="!allDataLoaded && !loadError" class="pb-3 pt-3 text-center">
            {{ $t('ui.dataLoading') }}&hellip;
          </div>

          <d-alert
            v-if="loadError"
            show
            theme="warning">
            {{ $t('ui.dataLoadingFailed') }} <a href="javascript:window.location.reload();" class="alert-link">{{ $t('ui.refreshPage') }}</a> {{ $t('ui.toTryAgain') }}
          </d-alert>
        </d-card>
      </validation-observer>
    </d-form>
  </d-container>
</template>

<script>
import CommonGetters from '../../utils/CommonGetters.js';
import Contacts from './Contacts.vue';
import FormUtils from '../../utils/FormUtils.js';
import SelectTag from './SelectTag';
import Vue from 'vue';

export default {
  name: 'market-customer-edit',
  components: {
    'contacts': Contacts,
    'select-tag': SelectTag
  },
  computed: {
    allDataLoaded () {
      return this.loaded && this.loadedWorkers && this.loadedTags && this.loadedCurrencies && this.loadedLanguages;
    },
    languagesOptions () {
      return [{ value: null, text: this.$t('settings.language.chooseLanguage') }].concat(this.languages.map(language => ({
        value: language.id,
        text: language.name
      })));
    },
    currenciesOptions () {
      return [{ value: null, text: this.$t('shipments.popups.selectCurrency') }].concat(CommonGetters.getCurrenciesForSelect(this.currencies));
    }
  },
  data () {
    return {
      id: 0,
      name: '',
      language_id: null,
      currency_id: null,
      invoice_postcode: '',
      invoice_city: '',
      invoice_street: '',
      invoice_building: '',
      invoice_locale: '',
      invoice_country_prefix: '',
      invoice_tax_number: '',
      country: '',
      contact_name: '',
      contact_surname: '',
      phone: '',
      email: '',
      account_manager_id: null,
      tag: '',
      customer_exists: false,
      website_url: '',
      shop_url: '',
      // data
      workers: [],
      contacts: [],
      languages: [],
      currencies: [],
      // helpers
      original_invoice_country_prefix: '',
      original_invoice_tax_number: '',
      // flags
      loaded: false,
      loadError: false,
      loadedCurrencies: false,
      loadedLanguages: false,
      loadedTags: false,
      loadedWorkers: false
    };
  },
  mounted () {
    this.loadData();
    this.loadAdditionalData();
    this.$bus.$on('market-customer-contacts-reload-needed', this.loadContacts);
    this.$bus.$on('market-customer-tags-loaded', this.tagsAreLoaded);
    this.$bus.$on('market-customer-data-load-error', this.loadErrorOccurred);
  },
  methods: {
    loadData () {
      FormUtils.loadItemData(this, {
        endpointBase: '/market-customers/item/',
        instanceFields: ['name', 'language_id', 'currency_id', 'invoice_postcode', 'invoice_city', 'invoice_street', 'invoice_building', 'invoice_locale', 'invoice_country_prefix', 'invoice_tax_number', 'country', 'contact_name', 'contact_surname', 'phone', 'email', 'tag', 'account_manager_id', 'contacts', 'customer_exists', 'website_url', 'shop_url'],
        params: {
          with: [
            'contacts',
            'accountManager'
          ]
        },
        loadedKey: 'loaded',
        successAction: () => {
          this.original_invoice_country_prefix = this.invoice_country_prefix;
          this.original_invoice_tax_number = this.invoice_tax_number;
          this.$refs['select-tag'].tagValue = this.tag;
        }
      });
    },
    loadAdditionalData () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/users/items',
        outputKey: 'workers',
        loadedKey: 'loadedWorkers',
        errorKey: 'loadError',
        params: {
          return: 'get',
          where: {
            type: ['admin', 'worker']
          }
        }
      });

      FormUtils.loadAdditionalData(this, {
        method: 'get',
        endpoint: '/languages/items',
        loadedKey: 'loadedLanguages',
        outputKey: 'languages',
        errorKey: 'loadError'
      });

      FormUtils.loadAdditionalData(this, {
        method: 'get',
        endpoint: '/currencies/items',
        loadedKey: 'loadedCurrencies',
        outputKey: 'currencies',
        errorKey: 'loadError',
      });
    },
    filterByForWorkers (option, label, search) {
      return (option.name).toLowerCase().indexOf(search.toLowerCase()) > -1;
    },
    loadContacts () {
      this.loaded = false;

      FormUtils.loadItemData(this, {
        endpointBase: '/market-customers/item/',
        instanceFields: ['contacts'],
        params: {
          with: ['contacts']
        },
        loadedKey: 'loaded'
      });
    },
    validateForm () {
      FormUtils.validate(this.$refs['market-customer-new-form'], this.submitForm);
    },
    submitForm () {
      let formDataToSend = {
        name: this.name,
        invoice_postcode: this.invoice_postcode,
        invoice_city: this.invoice_city,
        invoice_street: this.invoice_street,
        invoice_building: this.invoice_building,
        invoice_locale: this.invoice_locale,
        invoice_country_prefix: this.invoice_country_prefix,
        invoice_tax_number: this.invoice_tax_number,
        country: this.country,
        contact_name: this.contact_name,
        contact_surname: this.contact_surname,
        phone: this.phone,
        email: this.email,
        language_id: this.language_id,
        currency_id: this.currency_id,
        tag: this.$refs['select-tag'].tagValue,
        account_manager_id: this.account_manager_id,
        website_url: this.website_url,
        shop_url: this.shop_url
      };

      FormUtils.submit({
        $http: this.$http,
        endpoint: '/market-customers/update/' + parseInt(this.$route.params.id, 10),
        formData: formDataToSend,
        successTitle: this.$t('marketCustomers.editCustomerSuccessTitle'),
        successText: this.$t('marketCustomers.editCustomerSuccessText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('marketCustomers.editCustomerErrorText'),
        successAction: () => {
          this.$router.push('/klienci-z-targow/');
        }
      });
    },
    tagsAreLoaded () {
      this.loadedTags = true;
    },
    loadErrorOccurred () {
      this.loadError = true;
    },
    checkBeforeCreatingCustomer () {
      if (!this.customer_exists) {
        this.$router.push('/klienci/nowy/z-klienta-z-targow/' + parseInt(this.$route.params.id, 10));
      } else if (this.customer_exists && (!this.original_invoice_country_prefix || !this.original_invoice_tax_number)) {
        Vue.swal({
          title: this.$t('marketCustomers.emptyTaxDataTitle'),
          html: this.$t('marketCustomers.emptyTaxDataDesc'),
          type: 'warning',
          confirmButtonText: this.$t('ui.ok'),
          buttonsStyling: true
        });
      } else if (this.customer_exists) {
        Vue.swal({
          title: this.$t('marketCustomers.existingCustomerTitle'),
          html: this.$t('marketCustomers.existingCustomerDesc'),
          type: 'warning',
          confirmButtonText: this.$t('ui.ok'),
          buttonsStyling: true
        });
      }
    }
  },
  beforeDestroy () {
    this.$bus.$off('market-customer-contacts-reload-needed', this.loadContacts);
    this.$bus.$off('market-customer-tags-loaded', this.tagsAreLoaded);
    this.$bus.$off('market-customer-data-load-error', this.loadErrorOccurred);
  }
};
</script>
